// This file is auto-generated from elements/myrh-solutions-from-partners/data/affinityCategories.csv
// Do not edit this file directly

export const AFFINITY_CATEGORIES = {
  "Artificial intelligence": {
    "Category": "AI"
  },
  "Ansible features": {
    "Category": "DevOps"
  },
  "Application development and delivery": {
    "Category": "App Dev"
  },
  "Application modernization": {
    "Category": "App modernization"
  },
  "Automation and management": {
    "Category": "Automation"
  },
  "CI/CD": {
    "Category": "DevOps"
  },
  "Cloud automation": {
    "Category": "Cloud"
  },
  "Data science": {
    "Category": "Data management"
  },
  "DevSecOps": {
    "Category": "DevOps"
  },
  "Hybrid cloud": {
    "Category": "Cloud"
  },
  "Infrastructure automation": {
    "Category": "Infrastructure"
  },
  "Managed cloud": {
    "Category": "Cloud"
  },
  "Network automation": {
    "Category": "Networking"
  },
  "Open hybrid cloud": {
    "Category": "Cloud"
  },
  "SAP workloads": {
    "Category": "Infrastructure"
  },
  "Security automation": {
    "Category": "Security"
  },
  "Cloud services": {
    "Category": "Cloud"
  },
  "Containers": {
    "Category": "App modernization"
  },
  "Culture and process": {
    "Category": "DevOps"
  },
  "DevOps": {
    "Category": "DevOps"
  },
  "Edge computing": {
    "Category": "Edge"
  },
  "Integration": {
    "Category": "Automation"
  },
  "Kubernetes": {
    "Category": "App modernization"
  },
  "Linux": {
    "Category": "Infrastructure"
  },
  "Migration": {
    "Category": "Migration"
  },
  "Operations": {
    "Category": "DevOps"
  },
  "Security": {
    "Category": "Security"
  },
  "Virtualization": {
    "Category": "Virtualization"
  },
  "Event-Driven Ansible": {
    "Category": "Automation"
  },
  "Configuration management": {
    "Category": "Networking"
  },
  "Observability": {
    "Category": "IT & management tools"
  },
  "AI inference": {
    "Category": "AI"
  }
} as const;
